import { logCheckpointViaAjax } from '@eb/janus';

import logger from '@eb/logger-bugsnag';

export const logJanusCheckpoint = (checkpoint) => (dispatch, getState) => {
    const {
        event: { id: eventId },
        app: { isMobile },
    } = getState();
    const device = isMobile ? 'Mobile' : 'Desktop';

    logCheckpointViaAjax(`${checkpoint}_${device}`, {
        event_id: eventId,
    }).catch((error) => {
        logger.info(`janus checkpoint failed for: ${checkpoint}_${device}`, {
            error,
        });
    });
};
